import { useCmsContext } from "@rotorstudios/fe-cms";
import { useQuery } from "@tanstack/react-query";

import { useFetchCMSData } from "./useFetchCMSData";
import { CMS_DATA_SOURCES, CME_DATASOURCES_FEATURED_ACCESSORIES } from "./static";

const CACHE_TIME = 3 * 60 * 1000; // 3 minutes in ms

const useFeaturedAccessories = () => {
  const { fetchData } = useFetchCMSData();
  const { siloManifest } = useCmsContext();

  const path = siloManifest?.[CMS_DATA_SOURCES]?.get(
    CME_DATASOURCES_FEATURED_ACCESSORIES,
  );

  const getFeaturedAccessoriesData = async (): Promise<any> => {
    if (!path)
      throw new Error("Featured Accessories data source not found in silo manifest");
    const raw = await fetchData(path);
    return raw?.data;
  };

  const { data: featuredAccessoriesData } = useQuery({
    queryKey: ["featuredAccessoriesData", path],
    queryFn: () => getFeaturedAccessoriesData(),
    enabled: Boolean(path),
    staleTime: CACHE_TIME,
  });

  return { featuredAccessoriesData };
};

export default useFeaturedAccessories;
